{
    "button.copy": "Kopieren",
    "button.email": "E-Mail",
    "button.share": "Teilen",
    "button.sms": "SMS",
    "footer.poweredBy": "Unterstützt von <linkText> Ice Cream Social <\/linkText>",
    "footer.privacyPolicy": "Datenschutz-Bestimmungen",
    "footer.termsAndConditions": "Geschäftsbedingungen",
    "offer.hint": "Wenn {conversionGoal, plural, one {# Freund kauft ein } two {# Freunde kaufen ein } few {# Freunde kaufen ein } many {# Freunde kaufen ein } other {# Freunde kaufen ein }}, erhältst du deine Belohnung!",
    "optInMessage": "Um teilzunehmen und mit Ihren Freunden zu teilen, teilen Sie uns mit, wie wir Sie mit Angebots- und Prämien Aktualisierungen kontaktieren können",
    "order.confirmed": "Bestellung Nr. {orderId} bestätigt!",
    "order.details": "Siehe Bestelldetails",
    "share.email.duplicateError": "Hoppla! Sie haben diese E-Mail bereits hinzugefügt.",
    "share.email.heading": "Freunde per E-Mail einladen",
    "share.email.inputLabel": "die E-mail Adresse von einem Freund",
    "share.email.inputSubmit": "Eintreten",
    "share.email.invitesSubmit": "Sende Einladungen",
    "share.email.moreOptions": "Mehr Freigabeoptionen",
    "share.email.subheading": "Geben Sie unten die E-Mail-Adressen Ihrer Freunde ein",
    "share.general.help": "<bold> Probleme? <\/bold> Apps werden möglicherweise nicht geöffnet, wenn sie nicht auf Ihrem Gerät installiert sind. Versuchen Sie stattdessen, <bold2> Teilen <\/bold2> über Ihren persönlichen Link zu verwenden",
    "share.general.linkLabel": "Verwenden Sie Ihren persönlichen Link, um überall zu teilen",
    "share.general.otherOptions": "Oder jetzt auf diesen Plattformen teilen",
    "thankyou.dismissCTA": "Zurückweisen",
    "thankyou.heading": "Danke für das Teilen!",
    "thankyou.message": "Du bist ein Champion! Wir senden Ihnen Updates zu Ihrem Prämien fortschritt in Ihren Posteingang.",
    "thankyou.reminder": "Denken Sie daran, dass Sie dieses Angebot später jederzeit erneut aufrufen können, wenn Sie es weiter teilen möchten.",
    "thankyou.shareCTA": "Teilen Sie weiter",
    "unlock.consentExplanation": "Wir werden uns unter Verwendung der von Ihnen bereitgestellten Informationen mit Ihnen in Verbindung setzen. Sie können sich jederzeit abmelden, aber möglicherweise verpassen Sie Updates zu Ihrem Angebot",
    "unlock.consentPolicyExplanation": "Wir schätzen Ihre Privatsphäre. Um zu erfahren, wie Ihre Informationen verwendet werden, lesen Sie unsere <linkText> Datenschutz- und Cookie-Richtlinie <\/linkText>",
    "unlock.emailConsentOptIn": "Senden Sie mir Updates per E-Mail",
    "unlock.error.invalidEmail": "Bitte geben Sie eine gültige E-Mail-Adresse ein",
    "unlock.error.noConsent": "Bitte stimmen Sie der E-Mail-Kommunikation zu, um an diesem Angebot teilzunehmen",
    "unlock.input": "Deine E-Mail-Adresse",
    "unlock.label": "Angebot aktivieren",
    "share.general.copySuccess": "✨ Link kopiert!"
}